import React, { useState, useEffect } from 'react';
import './ImagesGallery.css';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
// רכיב לצורך הצגת התמונות
const ImageGallery = (props) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // פונקציה לשאיבת התמונות
  const fetchImages = async () => {
    try {
      const response = await axios.get('https://medical-center-znya.onrender.com/cloudinary/images');
      const imagesData = response.data;

      if (imagesData.length === 0) {
        setImages([]); // אם אין תמונות, עדכון המצב כ"ריק"
      } else {
        setImages(imagesData); // עדכון המצב עם התמונות שהתקבלו
      }
    } catch (err) {
      setError('Failed to fetch images'); // הצגת שגיאה במידה ויש בעיה בשאיבה
    } finally {
      setLoading(false); // סיום הטעינה
    }
  };
  const updateImgs = props.updateImgs;
  // קריאה לפונקציה fetchImages כשמרכיב ה-ImageGallery נטען
  useEffect(() => {

    fetchImages();
  }, [updateImgs]);

  // פונקציה למחיקת תמונה
  const handleDelete = async (publicId) => {
    try {
      const response = await axios.post('https://medical-center-znya.onrender.com/cloudinary/delete', { public_id: publicId });

      if (response.status === 200 && response.data.message === 'Image deleted successfully') {
        // אם המחיקה הצליחה, נסיר את התמונה מהמצב
        setImages(images.filter(image => image.public_id !== publicId));
        alert('Image deleted successfully!');
      } else {
        alert('Error deleting image.');
      }
    } catch (error) {
      console.error('Error deleting image:', error);
      alert('Error deleting image.');
    }
  };


  // הצגת טעינה אם התמונות עדיין לא נטענו
  if (loading) {
    return <div>Loading...</div>;
  }

  // הצגת הודעת שגיאה אם היתה בעיה בשאיבת התמונות
  if (error) {
    return <div>{error}</div>;
  }

  // אם אין תמונות, הצגת הודעה מתאימה
  if (images.length === 0) {
    return <div>No images found</div>;
  }

  // הצגת התמונות בגלריה
  return (
    <div className='ImagesGallery'>
      {images.map((image, index) => (
        <div className='imgGalleryCont' key={index}>
          <img className="imgGallery" src={image.secure_url} alt={`Image ${index}`} style={{ width: "200px" }} />
          <button className='deleteImg' onClick={() => handleDelete(image.public_id)}>
            <DeleteIcon />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;
